import type { Option } from '@solfacil/girassol/dist/types/components/forms/select/types';

export const APP_NAME = 'Loja Solfácil';
export const APP_DESCRIPTION =
  'Encontre, de maneira fácil, o kit solar ideal para o seu projeto. Zero burocracia, preço justo, entrega rastreada, suporte técnico disponível, melhores marcas e entrega garantida você só encontra aqui.';
export const CHANNEL = 'autoservico';

export const ORDER_OPTIONS: Option[] = [
  { name: 'Menor preço', value: 'price:asc' },
  { name: 'Maior preço', value: 'price:desc' },
  { name: 'Menor potência', value: 'power:asc' },
  { name: 'Maior potência', value: 'power:desc' },
];

export const SEARCH_MAX_SIZE = 50;

export const INSURANCE_INFO_PAGE_URL = 'https://solfacil.com.br/seguros';

export const STATES = [
  {
    value: 'RO',
    name: 'Rondônia',
  },
  {
    value: 'AC',
    name: 'Acre',
  },
  {
    value: 'AM',
    name: 'Amazonas',
  },
  {
    value: 'RR',
    name: 'Roraima',
  },
  {
    value: 'PA',
    name: 'Pará',
  },
  {
    value: 'AP',
    name: 'Amapá',
  },
  {
    value: 'TO',
    name: 'Tocantins',
  },
  {
    value: 'MA',
    name: 'Maranhão',
  },
  {
    value: 'PI',
    name: 'Piauí',
  },
  {
    value: 'CE',
    name: 'Ceará',
  },
  {
    value: 'RN',
    name: 'Rio Grande do Norte',
  },
  {
    value: 'PB',
    name: 'Paraíba',
  },
  {
    value: 'PE',
    name: 'Pernambuco',
  },
  {
    value: 'AL',
    name: 'Alagoas',
  },
  {
    value: 'SE',
    name: 'Sergipe',
  },
  {
    value: 'BA',
    name: 'Bahia',
  },
  {
    value: 'MG',
    name: 'Minas Gerais',
  },
  {
    value: 'ES',
    name: 'Espírito Santo',
  },
  {
    value: 'RJ',
    name: 'Rio de Janeiro',
  },
  {
    value: 'SP',
    name: 'São Paulo',
  },
  {
    value: 'PR',
    name: 'Paraná',
  },
  {
    value: 'SC',
    name: 'Santa Catarina',
  },
  {
    value: 'RS',
    name: 'Rio Grande do Sul',
  },
  {
    value: 'MS',
    name: 'Mato Grosso do Sul',
  },
  {
    value: 'MT',
    name: 'Mato Grosso',
  },
  {
    value: 'GO',
    name: 'Goiás',
  },
  {
    value: 'DF',
    name: 'Distrito Federal',
  },
];
